import type { Ref } from 'vue'
import { Placements } from '@ui/utils/placements'
import { computed, ref, watch } from 'vue'
import { useCollapseVisible } from '../collapse/collapseContext'

export function useDropdown(reference: Ref<HTMLElement | null> = ref(null)) {
  const show = ref(false)
  const collapseVisible = useCollapseVisible()

  if (collapseVisible) {
    watch(
      [collapseVisible, show],
      ([visible]) => {
        if (!visible) {
          show.value = false
        }
      },
      { flush: 'sync' },
    )
  }

  function open() {
    if (!show.value) {
      show.value = true
    }
  }

  function close() {
    if (show.value) {
      show.value = false
    }
  }

  function toggle() {
    show.value = !show.value
  }

  const placement = ref<Placements>(Placements.Bottom)

  const openStatus = computed(() => (show.value ? placement.value : false))

  return {
    show,
    placement,
    openStatus,
    open,
    close,
    toggle,
    reference,
    ignore: reference ? [reference] : [],
  }
}
